<script setup lang="ts">
import { twMerge } from 'tailwind-merge';

// PROPS
interface Props {
    title?: string;
    subTitle?: string;
    class?: string;
}

const { class: className } = defineProps<Props>();

// DATA
const mergedClass = twMerge('mb-9', className);
</script>

<template>
    <div :class="mergedClass">
        <h1 class="text-highlighted text-4xl font-bold" v-bind="$attrs" :class="{ 'mb-4': !!subTitle }">
            <slot>{{ title }}</slot>
        </h1>
        <p v-if="subTitle" class="text-base font-normal">{{ subTitle }}</p>
    </div>
</template>
